import type { StepKey } from "./onboarding-steps";

export type OnboardingProgress = Readonly<{
  signedIn: boolean;
  linked: boolean;
  uploaded: boolean;
  viewerName: string | null;
  player: Readonly<{
    id: string;
    name: string;
    avatarUrl: string | null;
  }> | null;
  agentName: string | null;
  policyName: string | null;
  policyVersion: number | null;
  policyArtifact: Readonly<{
    files: number;
    sizeBytes: number | null;
    kind: string | null;
  }> | null;
  experienceRequest: Readonly<{
    id: string;
    status: string;
    episodes: number;
    completed: number;
    failed: number;
  }> | null;
  leagueSubmission: Readonly<{ id: string; status: string }> | null;
}>;

export function doneOf({
  key,
  progress,
}: Readonly<{
  key: StepKey;
  progress: OnboardingProgress;
}>): boolean {
  switch (key) {
    case "signIn":
      return progress.signedIn;
    case "player":
      // The photo is optional: a named player completes the step.
      return progress.player !== null;
    case "handOff":
      return progress.linked;
    case "build":
      return progress.uploaded;
    case "request":
      return isLiveRequest(progress);
    case "submit":
      return isLiveSubmission(progress);
  }
}

export function isLiveRequest(progress: OnboardingProgress): boolean {
  const request = progress.experienceRequest;
  return (
    request !== null &&
    request.status !== "failed" &&
    request.status !== "cancelled"
  );
}

export function isLiveSubmission(progress: OnboardingProgress): boolean {
  const submission = progress.leagueSubmission;
  return (
    submission !== null &&
    submission.status !== "rejected" &&
    submission.status !== "withdrawn"
  );
}

export function isFinished(progress: OnboardingProgress): boolean {
  return isLiveSubmission(progress);
}
